import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
// import axios from "axios";
import useAxios from "../../utils/useAxios"; // Import the custom Axios instance
// import config from "../../config";

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState({
    total_event_approved_posts: "",
    total_event_posts: "",
    total_events: "",
    total_users: "",
  });
  const navigate = useNavigate(); // Initialize useNavigate
  const axiosAPI = useAxios(); // Use the custom hook for Axios

  // Get user informations from localStorage (assuming user info is stored there) - END
  const fetchDashboardData = async () => {
    let dashboardData;

    try {
      // First attempt to fetch the dashboard data
      const response = await axiosAPI.get(`/api/general/get-dashboard-data`);

      // If the request is successful, update the dashboard data
      dashboardData = response.data;
      setDashboardData(dashboardData);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      // If the error is not handled by the interceptor, log out the user
      if (error.response && error.response.status === 401) {
        navigate("/logout");
      }
    } finally {
      setLoading(false); // Set loading to false after data fetching is done
    }
  };

  // Fetch screens when component mounts
  useEffect(() => {
    fetchDashboardData();
  }, []);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="row">
          {/* Online Screens Card */}
          <div className="col-sm-6 col-md-3">
            <div className="card card-stats card-round">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-icon">
                    <div className="icon-big text-center icon-success bubble-shadow-small">
                      <i className="fas fa-chalkboard-teacher"></i>
                    </div>
                  </div>
                  <div className="col col-stats ms-3 ms-sm-0">
                    <div className="numbers">
                      <p className="card-category">Total Events</p>
                      <h4 className="card-title">
                        {dashboardData.total_events}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Offline Screens Card */}
          <div className="col-sm-6 col-md-3">
            <div className="card card-stats card-round">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-icon">
                    <div className="icon-big text-center icon-danger bubble-shadow-small">
                      <i className="fas fa-chalkboard"></i>
                    </div>
                  </div>
                  <div className="col col-stats ms-3 ms-sm-0">
                    <div className="numbers">
                      <p className="card-category">Total Post</p>
                      <h4 className="card-title">
                        {dashboardData.total_event_posts}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Total Screens Card */}
          <div className="col-sm-6 col-md-3">
            <div className="card card-stats card-round">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-icon">
                    <div className="icon-big text-center border ua-icon-gray bubble-shadow-small">
                      <i className="fas fa-desktop"></i>
                    </div>
                  </div>
                  <div className="col col-stats ms-3 ms-sm-0">
                    <div className="numbers">
                      <p className="card-category">Total Moderator</p>
                      <h4 className="card-title">
                        {dashboardData.total_users}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Total Media Files Card */}
          <div className="col-sm-6 col-md-3">
            <div className="card card-stats card-round">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-icon">
                    <div className="icon-big text-center ua-icon-gray bubble-shadow-small">
                      <i className="fas fa-folder-open"></i>
                    </div>
                  </div>
                  <div className="col col-stats ms-3 ms-sm-0">
                    <div className="numbers">
                      <p className="card-category">Total Approved Post</p>
                      <h4 className="card-title">
                        {dashboardData.total_event_approved_posts}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Storage Used Card */}
          <div className="col-sm-6 col-md-4 d-none">
            <div className="card card-stats card-round">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-icon">
                    <div className="icon-big text-center ua-icon-gray bubble-shadow-small">
                      <i className="fas fa-hdd"></i>
                    </div>
                  </div>
                  <div className="col col-stats ms-3 ms-sm-0">
                    <div className="numbers">
                      <p className="card-category">Total Decline Post</p>
                      <h4 className="card-title">0.32 GB</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Available Licenses Card */}
          <div className="col-sm-6 col-md-4 d-none">
            <div className="card card-stats card-round">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-icon">
                    <div className="icon-big text-center ua-icon-gray bubble-shadow-small">
                      <i className="fas fa-chalkboard"></i>
                    </div>
                  </div>
                  <div className="col col-stats ms-3 ms-sm-0">
                    <div className="numbers">
                      <p className="card-category">Available Licenses</p>
                      <h4 className="card-title">0</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Licenses Expiring Soon Card */}
          <div className="col-sm-6 col-md-4 d-none">
            <div className="card card-stats card-round">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-icon">
                    <div className="icon-big text-center ua-icon-gray bubble-shadow-small">
                      <i className="fas fa-user-shield"></i>
                    </div>
                  </div>
                  <div className="col col-stats ms-3 ms-sm-0">
                    <div className="numbers">
                      <p className="card-category">Licenses Expiring Soon</p>
                      <h4 className="card-title">0</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
